import { axiosInstance } from "./config";

// Get all appointments
export const getAllAppointments = async () => {
  const res = await axiosInstance.get("/appointments");
  return res.data;
};

// Create appointment
export const createAppointment = async (data) => {
  const res = await axiosInstance.post("/appointments", data, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return res.data;
};


// Update appointment (optional – future use)
export const updateAppointment = async (id, data) => {
  const res = await axiosInstance.post(`/appointments/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return res.data;
};

// Delete appointment
export const deleteAppointment = async (id) => {
  const res = await axiosInstance.delete(`/appointments/${id}`);
  return res.data;
};

// Bulk create appointments
export const bulkCreateAppointments = async (appointmentsArray) => {
  const res = await axiosInstance.post("/appointments/bulk", {
    appointments: appointmentsArray,
  });
  return res.data;
};

